import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { DrycutApolloProvider } from 'drycut-apollo';
import { Provider } from '@rollbar/react';
import { Configuration } from 'rollbar';
import router from './router';
import 'tailwindcss/tailwind.css';
import './styles.css';
import { env } from 'navigation';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const ROLLBAR_ACCESS_TOKEN = import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN;

const rollbarConfig: Configuration = {
  accessToken: ROLLBAR_ACCESS_TOKEN,
  environment: env,
  enabled: env === 'production',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
};

root.render(
  <Provider config={rollbarConfig}>
    <DrycutApolloProvider>
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>
    </DrycutApolloProvider>
  </Provider>,
);
